module.exports = __webpack_public_path__ + "img/basketball.1611e394.svg";